import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '../components/layout';
import styles from './NotFound.module.css';

/**
 * Catch-all 404 page. Mounted as `path="*"` in both the top-level
 * Routes block and the athena sub-Routes block in App.jsx, so any
 * unmatched URL (e.g. `/random`, `/athena/random`) lands here instead
 * of a blank screen.
 *
 * Project-workspace sub-paths (`/project/:projectId/<unknown>`) are
 * intentionally NOT caught here — the workspace route tree has its own
 * `*` fallback that renders OverviewTab so users stay inside the
 * workspace shell.
 */
export default function NotFound() {
  const navigate = useNavigate();
  return (
    <PageLayout activeNavItem="projects" disableScroll>
      <div className={styles.container}>
        <div className={styles.numeral}>404</div>
        <h1 className={styles.heading}>Page not found</h1>
        <p className={styles.body}>
          The page you were looking for doesn&apos;t exist or has been moved.
        </p>
        {/* Matches the "Create New Project" CTA on ProjectsListPage —
            uses the same `.actionPrimary` token recipe (flat
            --color-primary-blue, 36px height, radius-md). */}
        <button
          type="button"
          className={styles.cta}
          onClick={() => navigate('/projects')}
        >
          Return to Projects
        </button>
      </div>
    </PageLayout>
  );
}
